import { initializeApp } from "firebase/app";
import {getAuth,GoogleAuthProvider} from "firebase/auth";
const firebaseConfig = {
  apiKey: "AIzaSyDkvNCLYy8YlB2iRRcO8D-x0uCZav_Zggw",
  authDomain: "memyfolks-342a9.firebaseapp.com",
  projectId: "memyfolks-342a9",
  storageBucket: "memyfolks-342a9.appspot.com",
  messagingSenderId: "591607460746",
  appId: "1:591607460746:web:33f822538f54e21b058e73",
  measurementId: "G-DDCXV5DJ2C",
  plugin_name:"memyfolks"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app)
const provider = new GoogleAuthProvider();
provider.setCustomParameters({prompt:'consent'})
export {auth,provider};